module.exports = __webpack_public_path__ + "media/configurations/O-X-X-X-X-O-0e846c1c.png";